var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCirFiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    width: 32,
    height: 32,
    transform: "translate(1790 724)",
    fill: "#e03e6a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_78",
    "data-name": "Mask Group 78",
    transform: "translate(-1790 -724)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(1790.308 724)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2019",
    "data-name": "Path 2019",
    d: "M23.692,6.769H10.769a.923.923,0,0,1,0-1.846H23.692a.923.923,0,1,1,0,1.846Z",
    transform: "translate(-1.538)",
    fill: "#e03e6a",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2020",
    "data-name": "Path 2020",
    d: "M24.923,10.462H8.308a.923.923,0,1,1,0-1.846H24.923a.923.923,0,0,1,0,1.846Z",
    transform: "translate(-0.923 -0.923)",
    fill: "#e03e6a",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2021",
    "data-name": "Path 2021",
    d: "M25.1,28.923H6.281a2.591,2.591,0,0,1-2.589-2.589V14.9a2.591,2.591,0,0,1,2.589-2.589H25.1A2.591,2.591,0,0,1,27.692,14.9V26.334A2.591,2.591,0,0,1,25.1,28.923Z",
    transform: "translate(0 -1.846)",
    fill: "#e03e6a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirFiles);
export default __webpack_public_path__ + "static/media/cir_files.d3fdbbb6de89dfb32e6ab48a0375f611.svg";
export { ForwardRef as ReactComponent };